import { p as proxyCustomElement, H, h, d as Host } from './p-bfa0dc67.js';
import { c as classNames } from './p-df8c8ec2.js';

const biListCss = ".sr-only{position:absolute;height:1px;width:1px;padding:0;margin:-1px;overflow:hidden;border:0;left:-9999px;text-indent:-5000px;clip:rect(1px, 1px, 1px, 1px);}*,*:before,*:after{box-sizing:border-box}html,body,div,span,object,iframe,figure,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,code,em,img,small,strike,strong,sub,sup,tt,b,u,i,ol,ul,li,fieldset,form,label,table,caption,tbody,tfoot,thead,tr,th,td,main,canvas,embed,footer,header,nav,section,button,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;text-size-adjust:none}footer,header,nav,section,main{display:block}body{line-height:1.5}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}input{-webkit-appearance:none;appearance:none;border-radius:0}:host(:focus){outline:none !important;border:none !important}:host{width:100%;display:flex;flex-direction:column;align-items:start}::slotted(bi-list-item){flex-direction:column;gap:10px;align-items:start;display:flex}ul,li{margin-block-start:unset;margin-block-end:unset;padding-inline-start:unset;list-style:none;padding-top:4px;gap:10px;display:flex;flex-direction:column;width:100%}ul a,li a{text-decoration:none;color:inherit}ul.list-container.noGap{gap:0}";
const BiListStyle0 = biListCss;

const BiList$1 = /*@__PURE__*/ proxyCustomElement(class BiList extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.noGap = false;
    }
    render() {
        return (h(Host, { key: '143115b730549656d38c9282e1d377521ae54ecb' }, h("ul", { class: classNames('list-container', { name: this.name }, { noGap: this.noGap }), id: this.listId, key: this.listId }, h("slot", { key: 'a7652bb64186bd11328f4c742d94b6f4404c7989' }, h("li", { key: 'dbf0ff09f2c48bf3f03ceba4ee45c6931afcf4d5', class: 'list-item' }, "No items available")))));
    }
    static get style() { return BiListStyle0; }
}, [1, "bi-list", {
        "name": [1],
        "listId": [1, "list-id"],
        "noGap": [4, "no-gap"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-list"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-list":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiList$1);
            }
            break;
    } });
}

const BiList = BiList$1;
const defineCustomElement = defineCustomElement$1;

export { BiList, defineCustomElement };
